import { Component, Input } from '@angular/core'

import { MDBaseButtonComponent } from './base-button.component'

@Component({
  selector: 'bold-btn',
  templateUrl: 'bold-btn.component.html',
})
export class MDBoldButtonComponent extends MDBaseButtonComponent {}
